import request from "../utils/request";

export async function getUserList(payload) {
  return request.get("User/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      userId : payload.personal ? payload.personal.id : null,
      branchId : payload.branch ? payload.branch.id : null,
      roleId : payload.role ? payload.role.id : null,
      email : payload.userEmail && payload.userEmail.length > 0 ? payload.userEmail : null,
      phoneNumber : payload.userPhoneNumber && payload.userPhoneNumber.length > 0 ? payload.userPhoneNumber : null,
      userName: payload.userName,
      tcNumber: payload.userTcNumber && payload.userTcNumber.length > 0 ? payload.userTcNumber : null,
      active: payload.active
    }
  });
}

export async function getUserListForDealer(payload) {
  return request.get("User/ListForDealer", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      userId : payload.personal ? payload.personal.id : null,
      branchId : payload.branch ? payload.branch.id : null,
      roleId : payload.role ? payload.role.id : null,
      email : payload.userEmail && payload.userEmail.length > 0 ? payload.userEmail : null,
      phoneNumber : payload.userPhoneNumber && payload.userPhoneNumber.length > 0 ? payload.userPhoneNumber : null,
      userName: payload.userName,
      tcNumber: payload.userTcNumber && payload.userTcNumber.length > 0 ? payload.userTcNumber : null,
      active: payload.active
    }
  });
}

export async function getUserExcel(payload) {
  return request.get("User/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      userId : payload.personal ? payload.personal.id : null,
      branchId : payload.branch ? payload.branch.id : null,
      roleId : payload.role ? payload.role.id : null,
      email : payload.userEmail && payload.userEmail.length > 0 ? payload.userEmail : null,
      phoneNumber : payload.userPhoneNumber && payload.userPhoneNumber.length > 0 ? payload.userPhoneNumber : null,
      userName: payload.userName,
      tcNumber: payload.userTcNumber && payload.userTcNumber.length > 0 ? payload.userTcNumber : null,
      active: payload.active
    }
  });
}

export async function getUserExcelForDealer(payload) {
  return request.get("User/GetExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      userId : payload.personal ? payload.personal.id : null,
      branchId : payload.branch ? payload.branch.id : null,
      roleId : payload.role ? payload.role.id : null,
      email : payload.userEmail && payload.userEmail.length > 0 ? payload.userEmail : null,
      phoneNumber : payload.userPhoneNumber && payload.userPhoneNumber.length > 0 ? payload.userPhoneNumber : null,
      userName: payload.userName,
      tcNumber: payload.userTcNumber && payload.userTcNumber.length > 0 ? payload.userTcNumber : null,
      active: payload.active
    }
  });
}

export async function checkNewUserName(newUserName, id) {
  return request.get("User/CheckNewUserName?userName=" + newUserName + "&id=" + id);
}

export async function getPersonalReviewer(payload) {
  return request.get("User/PersonalReviewer?userId=" + payload.userId + "&month=" + payload.month.id);
}

export async function checkNewUserCode(userCode, userId, branchId) {
  return request.get("User/CheckNewUserCode?userCode=" + userCode + "&userId=" + userId + "&branchId=" + branchId);
}

export async function getRoleList() {
  let data = {
    pageIndex: 0,
    pageSize: 99
  };
  let query = serialize(data);
  return request.get("User/RoleList?" + query);
}

export async function getBranchNameList() {
  return request.get("User/BranchNameList");
}
export async function getPersonalNameList(branchId) {
  return request.get(`User/PersonalNameList?branchId=${branchId || 0}`);
}
export async function createNewUser(newUser) {
  return request.post("User/Create", newUser);
}
export async function updateUser(user) {
  return request.post("User/Update", user);
}
export async function deleteUser(id) {
  return request.delete('User/Delete?id=' + id);
}
export async function uploadImage(image) {
  return request({
    method: 'post',
    url: 'UploadImage/',
    data: image,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  });
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
export async function fetchUserWithCodes() {
  return new Promise((resolve, reject) => {
    request.get("user/getcodes").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

export async function needStockTransfer() {
  return new Promise((resolve, reject) => {
    request.get("user/NeedStockTransfer").then(res => {
      if(res && res.status === 200) {
        resolve(res.data)
      } else {
        reject(new Error(res.data.message));
      }
    }).catch((e) => {
      reject(e)
    })
  });
}

export async function setUserActive(id, active) {
  return request.post(`User/SetActive?id=${id}&active=${active}`);
}
